'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);


var _RocketPackages = require('./RocketPackages.scss');var styles = _interopRequireWildcard(_RocketPackages);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // styles
var
PackageDesktop = function (_Component) {_inherits(PackageDesktop, _Component);function PackageDesktop() {var _temp, _this, _ret;_classCallCheck(this, PackageDesktop);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    handleBuy = function () {var _this$props =
      _this.props,packageInstance = _this$props.packageInstance,handleChoosePackage = _this$props.handleChoosePackage;
      handleChoosePackage(packageInstance);
    }, _this.

    renderMostPopular = function () {var
      packageInstance = _this.props.packageInstance;
      var mostPopular = (0, _get2.default)(packageInstance, 'mostPopular', false);

      if (mostPopular) {
        return (
          _react2.default.createElement('div', { className: styles.mostPopularWrapper },
            _react2.default.createElement('p', { className: styles.mostPopular },
              _this.props.translate('mostPopular'))));



      }

      return null;
    }, _this.

    renderTopBlock = function () {var _this$props$packageIn =
      _this.props.packageInstance,packageInstance = _this$props$packageIn === undefined ? {} : _this$props$packageIn;
      var periods = (0, _get2.default)(packageInstance, 'periods', 0);

      return (
        _react2.default.createElement('div', { className: styles.countWrapper },
          _react2.default.createElement('p', { className: styles.periods }, periods),
          _react2.default.createElement('p', { className: styles.days },
            _this.props.translate('days'))));



    }, _this.

    renderPriceBlock = function () {var _this$props$packageIn2 =
      _this.props.packageInstance,packageInstance = _this$props$packageIn2 === undefined ? {} : _this$props$packageIn2;
      var price = (0, _get2.default)(packageInstance, 'period.' + packageInstance.periods + '.price', 0);
      var perDay = (0, _get2.default)(packageInstance, 'period.' + packageInstance.periods + '.perDay', 0);

      return (
        _react2.default.createElement('div', { className: styles.priceBlock },
          _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.perDay) }, '\u20AA',
            perDay, ' ', _this.props.translate('perDay')),

          _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.priceWrapper) },
            _react2.default.createElement('p', { className: styles.cost },
              _this.props.translate('price')),

            _react2.default.createElement('p', { className: styles.price }, '\u20AA',
              price))));




    }, _temp), _possibleConstructorReturn(_this, _ret);}PackageDesktop.prototype.

  render = function render() {
    return (
      _react2.default.createElement('div', { className: styles.questionPackageWrapper },
        this.renderMostPopular(),
        this.renderTopBlock(),
        this.renderPriceBlock(),
        _react2.default.createElement('button', {
            className: styles.actionButton,
            onClick: this.handleBuy },

          this.props.translate('buy'))));



  };return PackageDesktop;}(_react.Component);


PackageDesktop.propTypes = {
  locale: _propTypes2.default.string,
  isRtl: _propTypes2.default.bool,
  packageInstance: _propTypes2.default.object,
  translate: _propTypes2.default.func,
  handleChoosePackage: _propTypes2.default.func };exports.default =


PackageDesktop;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/RocketPackages/PackageDesktop.js
// module id = 2848
// module chunks = 0